import React from 'react'

export default function VariableSyntax({children}) {
	return (
		<span style={{color: "var(--shiki-token-keyword)"}}>
            {children}
		</span>
	)
}
